var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7825 16.7854C13.9919 16.7854 15.783 14.9943 15.783 12.7849C15.783 10.5755 13.9919 8.78442 11.7825 8.78442C9.57306 8.78442 7.78198 10.5755 7.78198 12.7849C7.78198 14.9943 9.57306 16.7854 11.7825 16.7854Z",
    stroke: "#525355",
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1635 20.0705L18.6884 16.7723L21.7822 15.5346V10.0356L18.6895 8.79836L19.1647 5.4995L14.4024 2.75L11.783 4.81102L9.16351 2.75L4.40124 5.4995L4.8763 8.79781L1.78223 10.0356V15.5346L4.87739 16.7728L4.40241 20.0705L9.16468 22.82L11.783 20.7599L14.4012 22.82L19.1635 20.0705Z",
    stroke: "#525355",
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.6bd67aa59aef2c7fa604c5059aa6318f.svg";
export { ForwardRef as ReactComponent };